import apiClient from '../config/api';

const rcaService = {
  /**
   * Get RCA records with optional filters
   * @param {number|null} machineId
   * @param {number|null} statusId
   * @returns {Promise<Array>}
   */
  getRcaRecords: async (machineId = null, statusId = null) => {
    const params = {};
    if (machineId) params.machineId = machineId;
    if (statusId) params.statusId = statusId;

    const response = await apiClient.get('/RcaRecord', { params });
    return response.data;
  },

  /**
   * Get RCA record including actions
   * @param {number} rcaId
   * @returns {Promise<object>}
   */
  getRcaRecordById: async (rcaId) => {
    const response = await apiClient.get(`/RcaRecord/${rcaId}`);
    return response.data;
  },

  /**
   * Create RCA record
   * @param {object} rcaData
   * @returns {Promise<object>}
   */
  createRcaRecord: async (rcaData) => {
    const response = await apiClient.post('/RcaRecord', rcaData);
    return response.data;
  },

  /**
   * Update RCA record
   * @param {number} rcaId
   * @param {object} rcaData
   * @returns {Promise<object>}
   */
  updateRcaRecord: async (rcaId, rcaData) => {
    const response = await apiClient.post(`/RcaRecord/update/${rcaId}`, rcaData);
    return response.data;
  },

  /**
   * Approve RCA record
   * @param {number} rcaId
   * @returns {Promise<object>}
   */
  approveRcaRecord: async (rcaId) => {
    const response = await apiClient.post(`/RcaRecord/${rcaId}/approve`);
    return response.data;
  },

  /**
   * Delete RCA record
   * @param {number} rcaId
   * @returns {Promise<object>}
   */
  deleteRcaRecord: async (rcaId) => {
    const response = await apiClient.post(`/RcaRecord/delete/${rcaId}`);
    return response.data;
  },

  /**
   * Get actions for an RCA
   * @param {number} rcaId
   * @returns {Promise<Array>}
   */
  getRcaActionsByRca: async (rcaId) => {
    const response = await apiClient.get(`/RcaAction/rca/${rcaId}`);
    return response.data;
  },

  /**
   * Create RCA action
   * @param {object} actionData
   * @returns {Promise<object>}
   */
  createRcaAction: async (actionData) => {
    const response = await apiClient.post('/RcaAction', actionData);
    return response.data;
  },

  /**
   * Update RCA action
   * @param {number} actionId
   * @param {object} actionData
   * @returns {Promise<object>}
   */
  updateRcaAction: async (actionId, actionData) => {
    const response = await apiClient.post(`/RcaAction/update/${actionId}`, actionData);
    return response.data;
  },

  /**
   * Complete RCA action
   * @param {number} actionId
   * @returns {Promise<object>}
   */
  completeRcaAction: async (actionId) => {
    const response = await apiClient.post(`/RcaAction/${actionId}/complete`);
    return response.data;
  },

  /**
   * Delete RCA action
   * @param {number} actionId
   * @returns {Promise<object>}
   */
  deleteRcaAction: async (actionId) => {
    const response = await apiClient.post(`/RcaAction/delete/${actionId}`);
    return response.data;
  },
};

export default rcaService;


